
<!-- NOTICE -->
<template>
    <div>
        <!-- // * CONTENT TITLE -->
        <v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 px-2 d-flex align-center white">
            <app-text category="content-title">
                <div class="d-flex align-center">
                    <v-icon v-if="form.slideStatus === 'LIVE'"  class="display-1 success--text icons8-checkmark-yes"></v-icon>
                    <v-icon v-if="form.slideStatus === 'DRAFT'" class="display-1 grey--text text--lighten-1 icons8-inactive-state"></v-icon>


                    <span v-if="formMode === 'New'" class="pl-2">{{ $t(`${langPath}.new`) }}</span>
                    <span v-else class="pl-2 d-inline-block text-truncate">{{ form[collectionItem + 'Name'] }} </span>
                </div>
            </app-text>
            <v-spacer></v-spacer>
            <appbutton :label="$t(`buttons.publish`)" v-if="form.slideStatus !== 'LIVE' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-checkmark-yes" type="success"  class="mr-0 pr-0" @click.native="updateItemStatus('LIVE')" showlabel="xlOnly" />                                                            
            <appbutton :label="$t(`buttons.hide`)" v-if="form.slideStatus === 'LIVE' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-inactive-state" type="error"  class="mr-0 pr-0" @click.native="updateItemStatus('DRAFT')" showlabel="xlOnly" />                                                            
            <!-- <uploadFilesButton v-show="formMode === 'New' || formMode === 'Edit'" :allowedTypes="'.pdf'" :buttonText="$t(`buttons.addPDF`)"/> -->
        </v-row>
        <v-divider class="grey lighten-1"></v-divider>
        <!-- // * CONTENT -->
        <v-container fluid class="pa-0"  >
            <v-row no-gutters class="">
                <v-col cols="12" xs="6" lg="12" class="">
                    <v-row class="ma-0" no-gutters>
                        <!-- // * TABS MENU -->
                        <v-tabs class="border-bottom-grey" v-model="tabs" height="53" show-arrows>
                            <v-tabs-slider color="red" background-color="black"></v-tabs-slider>
                            <v-tab href="#overview" class="white"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">{{ $t(`${langPath}.overview.tabName`) }}</span></v-tab>
                            <v-tab href="#viewer" class="white"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">{{ $t(`${langPath}.viewer.tabName`) }}</span></v-tab>
                        </v-tabs>
                        <!-- // * TABS ITEMS -->                        
                        <v-tabs-items v-model="tabs" class="appbackground">
                            <v-tab-item value="overview" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.overview.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.overview.text`) }}</app-text>                                                
                                                <v-divider class="my-4"/>
                                            </v-col>
                                            <!-- // * ACTION BAR -->
                                            <v-col class="pa-0 d-flex px-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton :label="$t(`buttons.undelete`)" v-if="formMode !== 'New' && form.delete !== undefined" icon="icons8-process" type="secondary"  class="mr-1" @click.native="undeleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.delete`)" v-if="formMode !== 'New' && form.delete === undefined" icon="icons8-trash" type="secondary"  class="mr-1" @click.native="deleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.edit`)" v-if="formMode !== 'New'" icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="editItem()" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly" />
                                                <v-spacer />
                                                <appbutton :label="$t(`buttons.cancel`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-cancel" type="grey darken-2"  class="mr-1" @click.native="cancelItem()" showlabel="xlOnly" />
                                                <appbutton :label="$t(`buttons.save`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-save" type="info"  class="mr-0" style="secondary" @click.native="validateForm()" showlabel="xlOnly" />                                                
                                            </v-col>                    
                                        </v-row>
                                        <!-- // * FORM -->  
                                        <v-form ref="form">
                                            <v-row class="mt-2" no-gutters>
                                                <v-col class="mt-2 px-3" cols="12" xs="12" sm="12" md="12">
                                                    <v-row dense>
                                                        <v-col class="pt-0 px-0 d-flex" cols="12">
                                                            <v-text-field color="black" :label="$t(`fields.name`)" v-model="form.slideName" :rules="rules.slideName" required filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}" class=""></v-text-field>
                                                        </v-col>
                                                        <v-col class="pt-1 pr-1 pl-0 d-flex" cols="6">
                                                            <v-text-field color="black" :label="$t(`fields.order`)" v-model="form.slideOrder" :rules="rules.slideOrder" required filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" class="" :class="{ 'disabled': formReadOnly}"></v-text-field>
                                                        </v-col>
                                                        <v-col class="pl-1 pr-0 pt-1 d-flex" cols="6">
                                                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" :label="$t(`fields.status`)" v-model="form.slideStatus" :rules="rules.slideStatus" required :items="slideStatusArray" filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" class="" :class="{ 'disabled': formReadOnly}" >
                                                                <template v-slot:item="data">{{ data.item.text }}</template>
                                                                <template v-slot:selection="data">{{ data.item.text }}</template>    
                                                            </v-select>
                                                        </v-col>
                                                        <v-col class=" pr-1 pl-0 pt-1 d-flex" cols="6">
                                                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" :label="$t(`fields.type`)" v-model="form.slideType" :rules="rules.slideType" required :items="slideTypeArray" filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" class="" :class="{ 'disabled': formReadOnly}">
                                                                <template v-slot:item="data">{{ data.item.text }}</template>
                                                                <template v-slot:selection="data">{{ data.item.text }}</template>                                                    
                                                            </v-select>
                                                        </v-col>
                                                        <v-col class=" pl-1 pr-0 pt-1 d-flex" cols="6">
                                                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" :label="$t(`fields.userTypes`)" v-model="form.userType" :rules="rules.userType" required :items="userTypesArray" item-text="text" multiple filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                                <template v-slot:selection="{ item, index }">
                                                                    <span v-if="index === 0">{{ item.text }}</span>
                                                                    <span v-if="index === 1" class="grey--text caption ml-2"> +{{ form.userType.length - 1 }} </span>
                                                                </template>                                                                                                                                                      
                                                            </v-select>
                                                        </v-col>
                                                        <v-col class="pl-0 pr-1 pt-1 d-flex" cols="6">
                                                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" :label="$t(`fields.icon`)" v-model="form.slideIcon" :rules="rules.slideIcon" required :items="icons" multiple filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}" :disabled="fileUpload">
                                                                <template v-slot:item="data">{{ data.item.text }}</template>
                                                                <template v-slot:selection="data">{{ data.item.text }}</template>                                                
                                                            </v-select>
                                                        </v-col>
                                                        <v-col class=" pr-0 pl-0 pt-2" cols="12">
                                                            <div>Please select which site/s this slide will apply to. If no sites are selected, this slide will apply to all sites.</div>
                                                            <v-autocomplete multiple :menu-props="{ top: false, offsetY: true }" :attach="true" color="black"  :label="$t('fields.site')" v-model="form.site" :rules="rules.siteID" filled required hide-details="auto" :background-color="formBackground" dense auto-select-first :items="sites" item-text="siteName" return-object :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-autocomplete>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-row dense class="d-flex pt-3 justify-start align-center">

                                                        <div class="font-weight-bold grey--text px-3" :class="fileUpload ? 'error--text' : 'grey--text'">Upload Slide?</div>
                                                        <v-switch v-model="fileUpload" class="secondary--text pa-0 ma-0" hide-details="auto" inset></v-switch>         
                                                        <v-spacer />
                                                        <docuploadbutton v-if="fileUpload" :allowedtypes="allowedTypes" :doclink="docLink" :folder="folder" class="mr-2"/>
                                                    </v-row>
                                                </v-col>

                                                <v-col v-if="(formMode === 'Edit' || formMode === 'New') && !fileUpload" class="my-2 px-2 pt-2 d-flex align-center justify-center" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                                    <v-row class="ma-0"  v-if="uploadedFile === undefined || uploadedFile === null" :allowedTypes="types">
                                                        <dragdrop :allowedTypes="types" :storagePath="storagePathProfilePic" :maxWidth="'200'"/>
                                                        <v-col cols="12" class="px-0 mx-0 pr-2">
                                                            <uploadFilesButton buttonText="Upload Image" :block="true" :storagePath="storagePathProfilePic"/>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row v-else>
                                                        <v-col v-if="uploadedFile != null">
                                                            <v-img max-width="220" height="250" contain style="border-radius: 5px" :src="uploadedFile.fileURL"></v-img>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col v-else-if="formMode == 'View' && !fileUpload" class="px-2 d-flex align-center justify-center" cols="12" xs="12" sm="6" md="4">
                                                    <v-row v-if="form.slideUrl != null" class="ma-0 d-flex align-center justify-center">
                                                        <v-img max-width="230" height="230" contain style="border-radius: 5px" :src="form.slideUrl"></v-img>
                                                    </v-row>
                                                    <v-row v-else class="justify-center ">
                                                        <v-col class="mt-6 d-flex align-center justify-center" cols="12" >
                                                            <v-icon size="50">icons8-image-document</v-icon>
                                                        </v-col>
                                                        <v-col class="d-flex align-center justify-center" cols="12" >
                                                            <h3 class="grey--text text--darken-3"> No Image Available</h3>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>

                                                <v-col v-if="!fileUpload" class="mb-4 px-2 mt-4" cols="12" xs="12" sm="8" md="8" lg="8" xl="8">
                                                    <vue-editor v-model="form.slideDesc" v-if="formMode === 'New' || formMode === 'Edit'"></vue-editor>
                                                    <div v-html="form.slideDesc" v-if="formMode === 'View'"></div>
                                                </v-col>
                                                <v-col v-if="fileUpload" class="mb-4 px-2 mt-4" cols="12">
                                                    <v-row v-if="form.slideUrl != null" class="ma-0 d-flex align-center justify-center">
                                                        <v-img max-width="600" height="300" contain style="border-radius: 5px" :src="form.slideUrl"></v-img>
                                                    </v-row>
                                                </v-col>

                                            </v-row>
                                            <!-- <pre>Form: {{ form }}</pre> -->
                                        </v-form>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                           
                           <v-tab-item value="viewer" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.viewer.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.viewer.text`) }}</app-text>                                                
                                                <v-divider class="my-4"/>
                                            </v-col> 
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-col cols="12" class="my-2 px-2">
                                    <v-container>
                                          <v-row justify="space-around">
                                            <v-card width="100%">
                                                <v-card-title class="secondary">
                                                    <v-row>
                                                         <v-col cols="6">
                                                              <v-img  height="40" contain position="left" :src="require('@/assets/tfw_logo.png')"  />
                                                         </v-col>
                                                         <!-- <v-col cols="6" class="ma-0 pa-0">
                                                              <v-row class="ma-0 pa-0 white--text caption text-center">
                                                                  <v-col class="ma-0 pa-0" cols="4">STAFF</v-col>
                                                                  <v-col  class="ma-0 pa-0"  cols="4">CONTRACTOR</v-col>
                                                                  <v-col  class="ma-0 pa-0"  cols="4">VISITOR</v-col>
                                                                  <v-col  class="ma-0 pa-0"  cols="4">
                                                                      <span v-if="form.userType.includes('STAFF')">Y</span>
                                                                      <span v-else>N</span>
                                                                  </v-col>
                                                                  <v-col  class="ma-0 pa-0"  cols="4">
                                                                       <span v-if="form.userType.includes('CONTRACTOR')">Y</span>
                                                                      <span v-else>N</span>
                                                                  </v-col>
                                                                  <v-col class="ma-0 pa-0"  cols="4">
                                                                       <span v-if="form.userType.includes('VISITOR')">Y</span>
                                                                      <span v-else>N</span>
                                                                  </v-col>
                                                              </v-row>
                                                         </v-col> -->
                                                    </v-row>
                                                  </v-card-title>
                                              
                                              <!-- <v-row class="" align="center" justify="center"></v-row> -->
                                              <v-card-text class="ma-0 pa-0">
                                                  <v-row class="ma-0 pa-0">
                                                      <v-col cols="12" height="40px" class="primary ma-0"></v-col>
                                                      <v-col class="ma-0 pa-0" v-if="uploadedFile !== undefined && uploadedFile !== null" cols="5">
                                                          <v-img  max-height="100%" max-width="100%" contain :src="uploadedFile.fileURL" ></v-img>
                                                      </v-col>
                                                      <v-col v-else cols="6">
                                                          <v-img max-height="100%" max-width="100%" contain :src="form.slideUrl" ></v-img>
                                                      </v-col>
                                                      <v-col cols="6">
                                                          <p class="headline"><v-icon size="50" color="primary">{{form.slideIcon}}</v-icon> {{ form.slideName }}</p>
                                                          <!-- <p class="subtitle-1">{{ form.slideDesc }}</p> -->
                                                          <div v-html="form.slideDesc"></div>
                                                      </v-col>
                                                  </v-row>
                                              </v-card-text>
                                            </v-card>
                                          </v-row>
                                    </v-container>
                                </v-col>
                           </v-tab-item>   
                        </v-tabs-items>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { mapGetters, mapState, mapActions } from 'vuex'; // Map the Getters from the Vuex Store
    import { VueEditor } from "vue2-editor";
    export default {
        components: {
          VueEditor
        },
        // * DATA
        data: () => ({
            // * PAGE DETAILS
            collection: 'slides',
            collectionTitle: 'Slides',
            collectionItem: 'slide',
            collectionItemTitle: 'Slide',
            langPath: 'slides.slide',
            tabs: 'overview', 
            tabs1:'viewer',
            // * FORM RELATED
            form: {
                id: '',
                slideOrder: null,
                slideName: '',
                slideType: [],
                slideStatus: '',
                userType: [],
                slideDesc: '',
                slideIcon: '',
                slideUrl: null,
                createdUserData: {},
                createdDateTime: '',
                modifiedUserData: {},
                modifiedDateTime: '',
            },
            rules: {},
            formMode: 'New', // Show Form in New Mode / Blank
            formReadOnly: false, // Make Form Editable
            formBackground: 'grey lighten-3',
            // * slide UPLOAD IMAGE
            types: "image/*" ,
            storagePathProfilePic: 'slides-pictures',

            // * slide RELATED
            slideTypeArray: [], // POPULATED FROM GETTER
            slideStatusArray: [], // POPULATED FROM GETTER
            userTypesArray:[],
            icons: [],
            sites: [], // Stores List of Sites
            fileUpload: false, // Show File Upload,


            // DOCUMENT UPLOAD
            allowedTypes: "image/*, text/*, .pdf, .PPT, .ppt, .PPTX, .pptx, .docx, .doc, .xls, .xlsx, .csv" ,
            folder: '',
        }),
        // * COMPUTED
        computed: {
            ...mapGetters({
                GET_openItem: 'GET_openSlide', // Get Open Slide Data
                GET_lookupValues: 'GET_lookupValues', // Get Lookup Values
                GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult', // Get Confirm Box Result
                GET_help: 'GET_help',
                GET_datePickerResult: 'datePicker_store/GET_datePickerResult', // Date Picker Results
                GET_sites: 'GET_sites', // Get Sites,
                GET_docUploadResult: 'docUpload_store/GET_docUploadResult', // GET docUpload Result
            }),
            ...mapState({
                uploadedFile: (state) => state.upload_file_store.file
            }),                
            // DOC LINK (GENERIC) - REQUIRED FOR DOCUMENT UPLOAD
            docLink() {
                var t = this;
                return ({ collection: t.collection, documentId: t.form.id })
            }
        },    
        // * WATCH
        watch: {
            // GET CONFIRMATION RESULT
            GET_confirmBoxResult: {
                handler: async function() {
                    var t = this;
                    if (t.GET_confirmBoxResult.data.collection === t.collection) {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, `${t.collectionItemTitle} Deleted`, deleteResult.data, null);
                                t.refreshItemView();
                            } else {
                                t.MIX_alert(-1, `Error Deleting ${t.collectionItemTitle}`, null, deleteResult.error);
                            }
                        }
                    } else {
                        // Do nothing
                    }
                }, deep: true
            },
            // * GET DOCUMENT UPLOAD RESULT
            GET_docUploadResult: {
                handler: async function() {
                    var t = this;
                    var docUploadResult = t.GET_docUploadResult;
                    // console.log('docUploadResult', JSON.stringify(docUploadResult, null, 2))

                    if (JSON.stringify(docUploadResult) !== '{}') {
                        t.form.slideUrl = docUploadResult.fileURL;
                    //     var updateDocumentResult = await t.MIX_updateDocumentFieldsById ('documents', t.form.id, { fileData: docUploadResult } )
                    //     if (updateDocumentResult.code === 1) {
                    //         t.MIX_createDocument('files', docUploadResult)
                    //         t.MIX_alert(1, 'Document Uploaded', updateDocumentResult.data, null);
                    //         setTimeout(function() {
                    //             t.refreshItemView();                                      
                    //             t.MIX_setPanelLayout(6, 6, true, 'Document', 'document');
                    //         }, 1000)
                    } else {
                        t.MIX_alert(-1, 'Error Uploading Document', null, updateDocumentResult.error);
                    }
                }, deep: true
            },
            // watch for changes to the file in the store
            uploadedFile: {
                handler: function() {
                    this.uploadedFile;
                },
                deep: true
            },
            // Probably we need this to be removed
            GET_datePickerResult: {
                // Watch for a change in the Date Picker Result and Update the Project Start or End Date based on the Date Picker Result Field
                handler() {
                    switch (this.GET_datePickerResult.field) {
                        // case 'projectStartDate': 
                        //     this.form.startDate = this.GET_datePickerResult.value; // Update the Form Start Date
                        //     this.formattedProjectStartDate = this.MIX_formatDateTime(this.form.startDate, 'x', 'DD-MMM-YYYY'); // Update the Formatted Project Start Date
                        //     break;
                        // case 'projectEndDate': 
                        //     this.form.endDate = this.GET_datePickerResult.value; // Update the Form End Date
                        //     this.formattedProjectEndDate = this.MIX_formatDateTime(this.form.endDate, 'x', 'DD-MMM-YYYY'); // Update the Formatted Project End Date
                        //     break;
                        default:
                            //do nothing
                            break
                    }
                }, deep: true
            },
            fileUpload: {
                handler: function() {
                    this.form.fileUpload = this.fileUpload;
                },
                deep: true
            }
        },     
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openSlide'}),            
            // UPDATE BREADCRUMBS
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                if (t.GET_openItem.process === 'New') {
                    breadcrumbs.push ({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}`}) // Set a Secondary Path
                } else {
                    breadcrumbs.push ({ name: `${this.GET_openItem.data[t.collectionItem + 'Name']}`, path: `/${t.collection}/${this.GET_openItem.data.id}`}) // Set a Secondary Path
                }
                this.MIX_breadcrumbs(breadcrumbs);
            },
            // OPEN ITEM
            openItem: async function() {
                var t = this;
                var openItem = await t.GET_openItem; // Get Open Item Data
                switch (openItem.process) {
                    case 'New': 
                        t.formMode = 'New'; // Show Form in New Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                    case 'View': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details            
                        t.formMode = 'View'; // Show Form in View Mode
                        t.formReadOnly = true; // Make Form Read Only
                        t.formBackground = 'grey lighten-3'; // Change Background Colour of Form
                        break;
                    case 'Edit': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details            
                        t.formMode = 'Edit'; // Show Form in Edit Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                }              
                return;
            },
            // EDIT ITEM
            editItem() {
                var t = this;
                t.formMode = 'Edit';
                t.formReadOnly = false;
                t.formBackground = 'white';
            },
            // CANCEL ITEM
            cancelItem() {
                var t= this;
                t.formMode = 'View';
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                t.removeUploadedDocument();
                t.refreshItemView();      
                t.closeRightPanel();  
            },
            closeRightPanel() {
                this.updateBreadcrumbs();
                this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
            },
            // SAVE ITEM
            saveItem: async function() {
                var t = this;
                if (t.form.id === undefined || t.form.id === null || t.form.id === '') {
                    t.form.id = t.MIX_generateId();  // if new then generate new id
                }                
                if (t.uploadedFile != null){
                   t.form.slideUrl = t.uploadedFile.fileURL;
                }
                var createDocumentResult = await t.MIX_createDocument(t.collection, t.form); // Create Document Within Firestore based on Form
                if (createDocumentResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null); // Send Success Alert to Item
                    t.formMode = 'View'; // Change Form Mode
                    t.formReadOnly = true; // Set Form to Read Only
                    t.formBackground = 'grey lighten-3';
                    t.refreshItemView();
                    t.removeUploadedDocument();
                } else {
                    t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null); // Send Error Alert to Item
                }
            },
            // * VALIDATION RULES
			validateForm() {
				let t = this;
                // console.log('validating form')
                if (this.fileUpload) {
                    t.rules = {
                        slideName: [
                            v => !!v || 'Slide Name is required',
                            v => (v && v.length < 255) || 'Name must be less than 255 characters',
                        ],
                        slideOrder: [v => !!v || 'Slide Order Required'],
                        slideStatus: [v => !!v || "Slide Status Required"],
                        slideType: [v => !!v || "Slide Type Required"],
                        userType: [v => !!v || "User Type Required"],
                        description: [v => !!v || 'Description Required'],
                    }
                } else {
                    t.rules = {
                        slideName: [
                            v => !!v || 'Slide Name is required',
                            v => (v && v.length < 255) || 'Name must be less than 255 characters',
                        ],
                        slideOrder: [v => !!v || 'Slide Order Required'],
                        slideStatus: [v => !!v || "Slide Status Required"],
                        slideType: [v => !!v || "Slide Type Required"],
                        userType: [v => !!v || "User Type Required"],
                        slideIcon: [v => !!v || 'Icon Required'],
                        description: [v => !!v || 'Description Required'],
                    }
                }
                //let the DOM update
                t.$nextTick(() => {
                    //manually trigger Vuetify validation
                    if(t.$refs.form.validate()) {  
                        this.saveItem();
                    } else {
                        t.MIX_alert(-1, "Please fill out all the fields", null, null);
                    }

                    //if not valid, errors will be automatically displayed
                })
			},
            // UPDATE ITEM STATUS
            updateItemStatus: async function(status) {
                var t = this;
                //console.log('updateResult')
                var updateResult = await t.MIX_updateDocumentFieldsById (t.collection, t.form.id, { [t.collectionItem + 'Status']: status } )
                //console.log('updateResult.code = ' + updateResult.code)
                if (updateResult.code === 1) {
                    t.MIX_alert(1, 'Status Updated', updateResult.data, null);
                    t.refreshItemView();
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateResult.error); 
                }
            },
            // REFRESH ITEM VIEW
            refreshItemView: async function() {
                var t = this;
                var itemResult = await t.MIX_readDocumentById(t.collection, t.form.id)
                var payload = {}
                payload.process = 'View';
                payload.popup = false;
                payload.data = itemResult.data;
                t.ACT_openItem(payload);
                t.openItem();
            },
            // DELETE ITEM METHOD
            deleteItem: function (id) {
                var t = this;
                t.MIX_confirmBox(
                    { 
                        show: true,
                        collection: t.collection,
                        id: id,
                        title: `Delete ${t.collectionItemTitle}`, 
                        description: `Are you sure you want to delete ${t.collectionItemTitle}: <br /><strong>${t.form[t.collectionItem + 'Name']}</strong>?`, 
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },
            // UNDELETE ITEM METHOD
            undeleteItem: async function (id) {
                var t = this;
                var undeleteResult = await t.MIX_undeleteDocument(t.collection, id)
                if (undeleteResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Restored`, undeleteResult.data, null);
                } else {
                    t.MIX_alert(-1, `Error Restoring ${t.collectionItemTitle}`, null, undeleteResult.error);
                   // console.log(`undeleteResult.error = ${JSON.stringify(undeleteResult.error, null, 2)}`)
                }
                t.refreshItemView();
            },
            // REMOVE UPLOADED DOCUMENT
            removeUploadedDocument(){
                this.$store.commit("upload_file_store/setFile", null); 
            },
        },
        async mounted() {
            var t = this;
            // * LOOKUP RELATED MOUNTED
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            t.slideTypeArray = await t.GET_lookupValues('SLIDETYPE');
            t.slideStatusArray = await t.GET_lookupValues('SLIDESTATUS')
            t.userTypesArray = await t.GET_lookupValues('SLIDEUSERSTYPE');
            t.icons = await t.GET_lookupValues('ICONS');
            // * GET slides
            t.slides = t.GET_slides; // STORE SITES IN LOCAL ARRAY
            t.sites = t.GET_sites; // STORE SITES IN LOCAL ARRAY

            // * ITEM RELATED MOUNTED
            var openItem = await t.GET_openItem; // Get Open Project Data
            t.formMode = openItem.process; // Show Form in View Mode
            if (openItem.process === 'New') { 
                t.formReadOnly = false;             // Make Form Editable }
                t.formBackground = 'white';
            } else {
                t.form = openItem.data; // Update the Form with the Open Project details    
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
            }
            if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Title
        }
    }
</script>

<style scoped>
    .disabled >>> .v-input__slot::before {
        border-style: none !important;
    }
    .v-text-field.v-text-field--enclosed {
        margin: 0;
        padding: 0;
        white-space: pre-wrap !important;
    }
</style>